// The theme lives on <html> as a `dark` class, not in React state. Tailwind's
// `dark:` variants restyle the whole page from that one class, so switching
// theme costs one style recalculation instead of re-rendering every component.

export const THEME_STORAGE_KEY = 'chatty_theme';

export function isDarkTheme() {
  return document.documentElement.classList.contains('dark');
}

// Called once before the app renders so the first paint is already themed.
export function initTheme() {
  document.documentElement.classList.toggle(
    'dark',
    localStorage.getItem(THEME_STORAGE_KEY) === 'dark'
  );
}

export function toggleTheme() {
  const root = document.documentElement;
  const next = !isDarkTheme();

  // Elements carrying a `transition` would otherwise ease into their new colours
  // while the rest snap, making the swap look staggered. Suppress transitions,
  // flush the new colours, then restore them — the swap lands in one paint.
  root.classList.add('theme-switching');
  root.classList.toggle('dark', next);
  void root.offsetWidth;
  root.classList.remove('theme-switching');

  localStorage.setItem(THEME_STORAGE_KEY, next ? 'dark' : 'light');
}
